import React from 'react';
import useReveal from '../hooks/useReveal';
import {
  Server,
  Network,
  ShieldCheck,
  Cloud,
  DatabaseBackup,
  Mail,
  KeyRound,
  GraduationCap
} from 'lucide-react';

const services = [
  {
    Icon: Server,
    title: 'Gestione Infrastrutture IT',
    description:
      'Progettiamo, implementiamo e gestiamo infrastrutture server fisiche e virtualizzate. Monitoraggio continuo, aggiornamenti pianificati e manutenzione proattiva per garantire uptime elevato e prestazioni ottimali in ogni momento.'
  },
  {
    Icon: Network,
    title: 'Reti Aziendali',
    description:
      'Dall\u2019architettura di rete al cablaggio strutturato, dalla configurazione di switch e router alla segmentazione VLAN. Realizziamo reti aziendali veloci, resilienti e sicure, sia in sede che in ambienti distribuiti su pi\u00f9 siti.'
  },
  {
    Icon: ShieldCheck,
    title: 'Cybersecurity',
    description:
      'Protezione multi-livello con le tecnologie leader del settore: EDR/XDR, firewall next-generation, SIEM, threat intelligence e vulnerability management. Rilevamento e risposta agli incidenti in tempo reale, 24 ore su 24.'
  },
  {
    Icon: Cloud,
    title: 'Cloud & Ambienti Ibridi',
    description:
      'Migrazione e gestione di workload su ambienti ibridi. Ottimizzazione dei costi, alta disponibilit\u00e0 e governance cloud per aziende che vogliono scalare senza perdere il controllo.'
  },
  {
    Icon: DatabaseBackup,
    title: 'Backup & Disaster Recovery',
    description:
      'Strategie di backup strutturate su pi\u00f9 livelli (locale, remoto, cloud) e piani di disaster recovery documentati e testati periodicamente. Garantiamo RPO e RTO certi per proteggere i dati critici della vostra azienda.'
  },
  {
    Icon: Mail,
    title: 'Email Security',
    description:
      'Filtraggio avanzato di phishing, malware, ransomware via email e attacchi Business Email Compromise. Proteggiamo ogni casella di posta aziendale con tecnologie anti-spam, sandboxing e analisi comportamentale dei messaggi.'
  },
  {
    Icon: KeyRound,
    title: 'Identity & Access Management',
    description:
      'Implementiamo modelli Zero Trust e soluzioni IAM enterprise per controllare con precisione chi accede ai sistemi aziendali. MFA, Single Sign-On, gestione dei privilegi e audit degli accessi per eliminare i rischi di compromissione delle identit\u00e0.'
  },
  {
    Icon: GraduationCap,
    title: 'Security Awareness',
    description:
      'La sicurezza informatica parte dalle persone. Organizziamo percorsi di formazione pratici e simulazioni di phishing per rendere il personale aziendale la prima linea di difesa contro le minacce pi\u00f9 comuni.'
  }
];

const ServiceCard = ({ Icon, title, description, idx }) => {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      className={`service-card reveal${visible ? ' reveal-visible' : ''}`}
      style={{ transitionDelay: `${(idx % 4) * 0.1}s` }}
    >
      <div className="service-icon-wrap">
        <Icon size={28} strokeWidth={1.5} />
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

const Services = () => {
  return (
    <section id="services" className="services-section">
      <h2 className="section-title">I nostri servizi</h2>
      <p className="section-subtitle">
        Offriamo una copertura completa dello stack tecnologico aziendale, dalla rete perimetrale
        fino agli endpoint degli utenti, con un approccio integrato e proattivo.
      </p>
      <div className="services-grid">
        {services.map((service, idx) => (
          <ServiceCard key={idx} idx={idx} {...service} />
        ))}
      </div>
    </section>
  );
};

export default Services;
